import { render, staticRenderFns } from "./policy-dialog.vue?vue&type=template&id=0ff96076&scoped=true"
import script from "./policy-dialog.vue?vue&type=script&lang=js"
export * from "./policy-dialog.vue?vue&type=script&lang=js"
import style0 from "./policy-dialog.vue?vue&type=style&index=0&id=0ff96076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff96076",
  null
  
)

export default component.exports